import angular from 'angular';
import moment from 'moment';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular
  .module('cloudX')
  .controller('AddBankAccountDialogCtrl', [
    'resourceFactorySvc',
    '$http',
    'appUrls',
    'flySvc',
    '$filter',
    '$element',
    'close',
    'relation',
    'enumCacheSvc',
    'translateListFilter',
    addBankAccountDialogCtrl,
  ]);

function addBankAccountDialogCtrl(
  resourceFactorySvc,
  $http,
  appUrls,
  flySvc,
  $filter,
  $element,
  close,
  relation,
  enumCacheSvc,
  translateListFilter,
) {
  var vm = this;
  vm.saving = false;
  vm.retrievingInfo = false;
  vm.showValidation = false;
  vm.dpDateOpen = false;
  vm.dpDateClosed = false;
  vm.dpCap = false;
  vm.bankAccountTypes = [];

  var resource = resourceFactorySvc.get('relationBankAccount');
  vm.bank = {
    relationId: relation.id,
    iban: '',
    bic: '',
    remark: '',
    bankName: '',
    isMain: false,
    bankAccountType: null,
    dateOpened: null,
    dateClosed: null,
    dateCap: null,
    countryCode: null,
    domiciliation: false,
    pitRefund: false,
  };

  enumCacheSvc.get('bankaccounttype').then(function(data) {
    vm.bankAccountTypes = data
      .map(x => ({
        ...x,
        label: translateListFilter(x.key, 'bankaccounttype', x.value),
      }))
      .sort(dynamicSort('label'));
  });

  vm.fillBankInfo = function() {
    if (vm.saving) return;
    if (!vm.bank.iban) return;
    if (vm.bankForm.iban.$invalid) return;
    if (vm.bank.iban.toLowerCase().startsWith('be')) {
      vm.retrievingInfo = true;
      const params = { iban: vm.bank.iban };
      $http.get(`${appUrls.api}/Api/Bank`, { params }).then(
        function({ data }) {
          if (!vm.saving && !!data && data.bic && vm.bank.iban === params.iban) {
            if (!vm.bank.bic) vm.bank.bic = data.bic;
            if (!vm.bank.bankName && data.name) vm.bank.bankName = data.name;
          }
          vm.retrievingInfo = false;
        },
        function() {
          vm.retrievingInfo = false;
        },
      );
    }
    vm.bank.countryCode = vm.bank.iban.substring(0, 2);
  };

  vm.save = function() {
    if (vm.bankForm.$invalid) return '';
    if (vm.saving) return '';

    vm.saving = true;
    resource.save(vm.bank).$promise.then(
      function(result) {
        vm.saving = false;
        flySvc.success();
        close(result, 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
